// Resumo antes de adicionar (produto com combo/etapas): tipo, escolhas com
// "Alterar", observação e quantidade.
import { ClipboardList } from "lucide-react";

import { fmt } from "../../lib/helpers";
import ControleQuantidade from "./ControleQuantidade";

export default function ResumoProduto({ h }) {
  const { isCombo, selectedComboType, comboPrice, simplePrice, comboPricePromo, simplePricePromo, getSelectionsSummary, setComboStep, observation, setObservation } = h;
  const resumo = getSelectionsSummary();
  const precoBase = selectedComboType === "combo" ? comboPrice : simplePrice;
  const promo = selectedComboType === "combo" ? comboPricePromo : simplePricePromo;
  return (
    <div className="max-w-4xl space-y-6" data-e2e="produto-resumo">
      <h2 className="text-3xl font-black text-zinc-100">Confirme seu pedido</h2>
      <div className="bg-zinc-900 rounded-2xl p-5 space-y-3 border border-zinc-800">
        <h4 className="font-semibold text-zinc-100 flex items-center gap-2"><ClipboardList className="w-5 h-5" />Suas escolhas</h4>
        {isCombo && (
          <div className="flex justify-between items-center py-2 border-b border-zinc-800">
            <div><p className="text-xs text-zinc-500">Tipo</p><p className="text-lg font-semibold text-zinc-100" data-e2e="resumo-tipo">{selectedComboType === "combo" ? "🍟 COMBO" : "INDIVIDUAL"}</p></div>
            {promo != null && promo !== precoBase ? <p><span className="text-sm line-through text-zinc-500 mr-2">R$ {fmt(precoBase)}</span><span className="text-lg font-bold text-green-500">R$ {fmt(promo)}</span></p> : <p className="text-lg font-bold text-primary">R$ {fmt(precoBase)}</p>}
          </div>
        )}
        {resumo.map((sel, idx) => (
          <div key={idx} className={`py-2 ${idx < resumo.length - 1 ? "border-b border-zinc-800" : ""}`}>
            <div className="flex justify-between items-start mb-1"><p className="text-xs text-zinc-500">{sel.stepName}</p><button type="button" onClick={() => setComboStep(sel.stepIndex + 1)} className="text-primary text-sm underline">Alterar</button></div>
            {sel.items.map((it, ii) => (<div key={ii} className="flex justify-between items-center"><p className="text-zinc-100">{it.name}</p>{it.price > 0 ? <span className="font-semibold text-primary">+R$ {fmt(it.price)}</span> : <span className="text-xs text-emerald-400">Incluso</span>}</div>))}
          </div>
        ))}
      </div>
      <div>
        <label className="text-sm font-medium mb-2 block text-zinc-300">Observação (opcional)</label>
        <textarea value={observation} onChange={(e) => setObservation(e.target.value)} placeholder="Ex: sem cebola, molho à parte..." rows={2} className="w-full resize-none rounded-xl bg-zinc-900 border border-zinc-700 text-zinc-100 p-3 text-base focus:outline-none focus:border-primary" />
      </div>
      <ControleQuantidade h={h} />
    </div>
  );
}
